import React, { useState } from 'react';
import './registration.css';
import landingImage from '../../../assets/images/landing.jpeg';
import linkedin from '../../../assets/images/linkedin.png';
import arrow from '../../../assets/icons/arrow-right-line.svg';
import API from '../../../api';

function Registration() {
  const [formData, setFormData] = useState({
    name: '',
    surname: '',
    phone: '',
    email: '',
    password: 'Password123.',
    domain: 'starportloans',
    broker_id: 2989,
  });

  const [errors, setErrors] = useState({
    name: '',
    surname: '',
    phone: '',
    email: '',
  });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [id]: '',
    }));
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = { name: '', surname: '', phone: '', email: '' };

    if (!formData.name.trim()) {
      newErrors.name = 'Name is required';
      isValid = false;
    }
    if (!formData.surname.trim()) {
      newErrors.surname = 'Surname is required';
      isValid = false;
    }
    if (!formData.phone.trim() || !/^\d+$/.test(formData.phone)) {
      newErrors.phone = 'Valid phone number is required';
      isValid = false;
    } else if (formData.phone.trim().length > 12) {
      newErrors.phone = 'Phone number must not exceed 12 digits';
      isValid = false;
    }
    if (!formData.email.trim() || !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
      newErrors.email = 'Valid email is required';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  async function onSubmit(event) {
    event.preventDefault();

    if (!validateForm()) return;

    try {
      const api = API();

      const registrationResponse = await api.post('/sign_in/borrower/register', formData);
      const { id: borrowerId, access_token } = registrationResponse.data;

      if (!borrowerId) {
        throw new Error('Failed to get borrower ID after registration');
      }

      const larResponse = await api.get(
        `/LAR/creation/data_for_form?borrower_id=${borrowerId}&creator=Borrower&originator=Borrower&lead_source=FBLP1`,
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        },
      );
      const { token: larToken, lar_id } = larResponse.data;

      if (!larToken) {
        throw new Error('Failed to get LAR token');
      }

      const webhookUrl = 'https://hooks.zapier.com/hooks/catch/15083761/2waabq1/';

      fetch(webhookUrl, {
        method: 'POST',
        mode: 'no-cors',
        body: JSON.stringify({
          attempt: borrowerId,
          id: borrowerId,
          request_id: borrowerId,
          status: 'success',
          lead_source: 'FBLP1',
          name: formData.name,
          surname: formData.surname,
          phone: formData.phone,
          email: formData.email,
          lar_token: larToken,
          lar_id,
        }),
      });

      const cognitoUrl = `https://www.cognitoforms.com/Starport1/StarportRealEstateFinancingRequestDevUpdated${larToken}`;
      window.location.href = cognitoUrl;
    } catch (error) {
      console.error('Error in onSubmit:', error);
    }
  }

  return (
    <div className="registration-wrapper">
      <header className="header">
        <div className="header-inner">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="399"
            height="55"
            viewBox="0 0 399 55"
            fill="none"
          >
            <mask
              id="mask0_732_902"
              style={{ maskType: 'alpha' }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="399"
              height="55"
            >
              <rect y="0.388672" width="398.208" height="54.6113" fill="url(#pattern0_732_902)" />
            </mask>
            <g mask="url(#mask0_732_902)">
              <rect y="0.388672" width="398.208" height="54.6113" fill="white" />
            </g>
            <defs>
              <pattern id="pattern0_732_902" patternContentUnits="objectBoundingBox" width="1" height="1">
                <use xlinkHref="#image0_732_902" transform="matrix(0.00334495 0 0 0.0243902 -0.00174216 0)" />
              </pattern>
              <image
                id="image0_732_902"
                width="300"
                height="41"
                xlinkHref="data:image/png;base64,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"
              />
            </defs>
          </svg>
        </div>
      </header>

      <section
        className="hero-section"
        style={{
          backgroundImage: `
            linear-gradient(to bottom, rgba(0, 0, 0, 1), rgba(1, 1, 4, 0) 500px),
            linear-gradient(to top, rgba(0, 0, 0, 1), rgba(1, 1, 4, 0) 900px),
            url(${landingImage})
          `,
        }}
      >
        <div className="hero-inner">
          <div className="hero-general">
            <h3 className="hero-title">Get Your Property Funded Now</h3>
            <p className="hero-text">
              Receive multiple quotes from pre-vetted lenders that compete for your loan. DIY or access expertise from
              our team of mortgage mentors. Be confident you've covered the market.
            </p>
          </div>
          <div className="hero-form">
            <h3 className="form-title">Start here</h3>
            <form className="form" onSubmit={onSubmit}>
              <div className="field">
                <label className="label" htmlFor="name">
                  First Name*
                </label>
                <input className="input" id="name" value={formData.name} onChange={handleChange} />
                {errors.name && <p className="error-text">{errors.name}</p>}
              </div>

              <div className="field">
                <label className="label" htmlFor="surname">
                  Last Name*
                </label>
                <input className="input" id="surname" value={formData.surname} onChange={handleChange} />
                {errors.surname && <p className="error-text">{errors.surname}</p>}
              </div>

              <div className="field">
                <label className="label" htmlFor="phone">
                  Phone*
                </label>
                <div className="phone-field">
                  <input maxLength={12} className="input" id="phone" value={formData.phone} onChange={handleChange} />
                  {errors.phone && <p className="error-text">{errors.phone}</p>}
                </div>
              </div>

              <div className="field">
                <label className="label" htmlFor="email">
                  Email*
                </label>
                <input type="email" className="input" id="email" value={formData.email} onChange={handleChange} />
                {errors.email && <p className="error-text">{errors.email}</p>}
              </div>

              <button className="btn-secondary" type="submit">
                Continue
              </button>
            </form>
          </div>
        </div>
        <div className="triangle" />
      </section>

      <section className="info-section">
        <div className="info-wrapper">
          <p className="info-text">
            Don’t need a loan right now? <span className="info-link">Get prepared for your next deal.</span>
          </p>
          <a href="https://cal.com/peter681/starport-demo" target="_blank" className="info-btn" rel="noreferrer">
            <p>Learn more about Starport</p>
            <img src={arrow} alt="Arrow Icon" className="arrow-icon" />
          </a>
        </div>
      </section>

      <footer className="footer">
        <div className="footer__inner">
          <p className="footer-text">
            Copyright © 2024 Starport. All rights reserved.
            <a href="https://starportco.com/privacy-policy/" className="footer-link">
              Privacy Policy
            </a>{' '}
            |{' '}
            <a href="https://starportco.com/terms-conditions/" className="footer-link">
              Terms of Use
            </a>
          </p>
          <a
            className="social-link"
            href="https://www.linkedin.com/company/starportco/"
            target="_blank"
            rel="noreferrer"
          >
            Follow us
            <img src={linkedin} alt="LinkedIn" />
          </a>
        </div>
      </footer>
    </div>
  );
}

export default Registration;
